<template>
  <register-user-component />
</template>
    
<script>
import RegisterUserComponent from "../components/register-user/Index.vue";

export default {
  name: "Login",
  components: {
    RegisterUserComponent,
  },
  data: () => ({}),
};
</script>
    
<style>
</style>